// Skills are named bundles of instructions that steer the assistant toward a
// specific task with less prompting. For now the active skill's instructions
// are appended to the system prompt. Later this can become progressive
// disclosure (a `load_skill` tool) so many skills don't bloat the prompt.

export type Skill = {
	id: string,
	name: string,
	description: string,
	instructions: string,
}

export const skills: Skill[] = [
	{
		id: 'translate',
		name: 'Translate fields',
		description: 'Translate localized text fields of the current entry.',
		instructions:
			'The user wants to translate content of the current entry.\n' +
			'1. Call list_content_fields to find localized text fields (types Symbol/Text).\n' +
			'2. Call get_current_entry to read the existing values.\n' +
			'3. For each target locale, translate from the source locale and write it with set_field.\n' +
			'Preserve meaning, tone and any markup. Never translate slugs, IDs or URLs. ' +
			'Report a short summary of what you translated.',
	},
]

export function getSkill(id: string | null): Skill | undefined {
	if (!id) return undefined
	return skills.find(s => s.id === id)
}
